module.exports = __webpack_public_path__ + "static/media/OB.c5f2da65.png";